<script>
  let { children, title } = $props()
</script>

<svelte:head>
  {#if title}
    <title>{title}</title>
  {/if}
</svelte:head>

<main class="bg-white rounded-2xl shadow-sm border border-gray-200 flex-1 min-h-full">
  {@render children?.()}
</main>